module.exports = __webpack_public_path__ + "img/resw.0921e862.png";